export default {
  namespaced: true,
  state: {
    // 音频播放状态
    autoPalyer: false,
    // 播放状态
    audioState: "ended",
    // 播放器链接
    audioSrc: null,
    // 显示隐藏拖拽演示效果
    quiz_match: {},
  },
  mutations: {
    // 播放器开关
    setAutoPlayer(state, bol) {
      state.autoPalyer = bol;
    },
    // 设置播放状态
    setAudioState(state, str) {
      state.audioState = str;
    },
    // 修改音频链接
    setAudioSrc(state, str) {
      state.audioSrc = str;
    },
    // 显示隐藏拖拽演示效果
    setQuizMatch(state, json) {
      state.quiz_match = json;
    },
    // quiz_match(state, quizMatch) {
    //     state.quiz_match = quizMatch
    // },
  },
};
